setTimeout(() => {
    const button = document.querySelector('.gfbVolumeDiscountWidgetOfferAddToCartButton');  
    const buttonContainer = document.querySelector('.gfbVolumeDiscountWidgetOfferAddToCartButton').parentElement;
    let klaviyoForm = document.querySelector('.klaviyo-form');
    let atcSticky = document.querySelector('#sticky-atc');
    if (button) {
        button.style.pointerEvents = 'none';
        buttonContainer.style.cursor = 'not-allowed';
        button.style.opacity = '0.5';
        button.textContent = 'COMING SOON';
        klaviyoForm.style.display = 'flex';
        atcSticky.style.display = 'none';
    }
}, 2000);